import React, { useEffect, useState } from "react";
import { Offcanvas, Form } from "react-bootstrap";
import Common_Back_Btn from "../../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Certification_Modal from "../../../../../../../common/common_modal/certification_modal/Certification_Modal";
import { GetSingle } from "../../../../../../../features/admin/quality_management/structural_requirement/legal_entity/Slice";
import { useDispatch } from "react-redux";

function Legel_Entity_view_offcanvas({ show, handleClose, id }) {
  const [showModal, setShowModal] = useState(false);
  const [details, setDetails] = useState(null);
  const [modalImage, setModalImage] = useState(null);
  const dispatch = useDispatch();
  const GetData = async (id) => {
    const res = await dispatch(GetSingle(id));

    if (res?.payload?.success) {
      setDetails(res.payload.data);
    }
  };

  useEffect(() => {
    if (show === true && id) {
      GetData(id);
    }
  }, [show]);
  // console.log("legaldetailsdetails", details);

  const fileUrl = details?.companies_act_certificate
    ? `${process.env.REACT_APP_IMG_URL}${details?.companies_act_certificate}`
    : null;

  const getFileType = (url) => {
    if (!url) return "";

    const ext = url
      .split(".")
      .pop()
      .toLowerCase();

    if (["jpg", "jpeg", "png", "gif", "webp"].includes(ext)) return "image";
    if (ext === "pdf") return "pdf";
    if (["doc", "docx"].includes(ext)) return "word";
    if (["xls", "xlsx"].includes(ext)) return "excel";

    return "other";
  };

  const fileType = getFileType(fileUrl);

  const fileUrlAttach = details?.attach_file
    ? `${process.env.REACT_APP_IMG_URL}${details?.attach_file}`
    : null;

  const fileTypeAttach = getFileType(fileUrlAttach);
  return (
    <>
      <Offcanvas
        className="mobile_offcanvas Imperiality_view_offcanvas common_offcanvas"
        show={show}
        placement="end"
        onHide={handleClose}
      >
        <Offcanvas.Header>
          <Offcanvas.Title>
            <div className="back_div" onClick={handleClose}>
              <Common_Back_Btn />
            </div>
            View Legal Entity
          </Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body>
          <div className="white_container customer_section">
            <div className="row">
              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Legal Entity Name</Form.Label>
                  <Form.Control value={details?.name} disabled />
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Legal Entity Type</Form.Label>
                  <Form.Control value={details?.legal_entity} disabled />
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Date of Establishment</Form.Label>
                  <Form.Control
                    value={details?.date_of_establishment}
                    disabled
                  />
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Type Of Service</Form.Label>
                  <Form.Control
                    value={details?.other_accereditation}
                    disabled
                  />
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group file_field">
                  <Form.Label>Companies Act Certificate</Form.Label>
                  <div className="image_holder">
                    {/* IMAGE */}
                    {fileType === "image" && (
                      <img
                        className="img_preview"
                        src={fileUrl}
                        alt="preview"
                      />
                    )}

                    {/* PDF */}
                    {fileType === "pdf" && (
                      <iframe
                        src={fileUrl}
                        title="PDF Preview"
                        width="100%"
                        height="100px"
                      />
                    )}

                    {/* WORD */}
                    {fileType === "word" && (
                      <iframe
                        src={`https://docs.google.com/gview?url=${fileUrl}&embedded=true`}
                        title="Word Preview"
                        width="100%"
                        height="100px"
                      />
                    )}

                    {/* EXCEL */}
                    {fileType === "excel" && (
                      <iframe
                        src={`https://docs.google.com/gview?url=${fileUrl}&embedded=true`}
                        title="Excel Preview"
                        width="100%"
                        height="300px"
                      />
                    )}

                    {/* DEFAULT / UNKNOWN */}
                    {fileType === "other" && (
                      <img
                        className="img_preview"
                        src="/assets/images/other/dummy-image.png"
                        alt="no preview"
                      />
                    )}
                  </div>

                  <div className="span_text_holder">
                    <div></div>

                    <div>
                      <span
                        className="green_text"
                        onClick={() => {
                          setShowModal(true);
                          setModalImage(
                            details?.companies_act_certificate
                              ? `${process.env.REACT_APP_IMG_URL}${details?.companies_act_certificate}`
                              : null,
                          );
                          handleClose();
                        }}
                      >
                        <FontAwesomeIcon icon={faEye} className="me-2" /> View
                      </span>
                    </div>
                  </div>
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group file_field">
                  <Form.Label>
                    Attached File <sub>(i.e pancard/ adhar card)</sub>
                  </Form.Label>
                  <div className="image_holder">
                    {/* IMAGE */}
                    {fileTypeAttach === "image" && (
                      <img
                        className="img_preview"
                        src={fileUrlAttach}
                        alt="preview"
                      />
                    )}

                    {/* PDF */}
                    {fileTypeAttach === "pdf" && (
                      <iframe
                        src={fileUrlAttach}
                        title="PDF Preview"
                         width="100%"
                        height="100px"
                      />
                    )}

                    {/* WORD */}
                    {fileTypeAttach === "word" && (
                      <iframe
                        src={`https://docs.google.com/gview?url=${fileUrlAttach}&embedded=true`}
                        title="Word Preview"
                        width="100%"
                        height="300px"
                      />
                    )}

                    {/* EXCEL */}
                    {fileTypeAttach === "excel" && (
                      <iframe
                        src={`https://docs.google.com/gview?url=${fileUrlAttach}&embedded=true`}
                        title="Excel Preview"
                        width="100%"
                        height="300px"
                      />
                    )}

                    {/* DEFAULT / UNKNOWN */}
                    {fileTypeAttach === "other" && (
                      <img
                        className="img_preview"
                        src="/assets/images/other/dummy-image.png"
                        alt="no preview"
                      />
                    )}
                  </div>
                  <div className="span_text_holder">
                    <div>{/* <span>Front Side</span> */}</div>

                    <div>
                      <span
                        className="green_text"
                        onClick={() => {
                          setShowModal(true);
                          setModalImage(
                            details?.attach_file
                              ? `${process.env.REACT_APP_IMG_URL}${details?.attach_file}`
                              : null,
                          );
                          handleClose();
                        }}
                      >
                        <FontAwesomeIcon icon={faEye} className="me-2" /> View
                      </span>
                    </div>
                  </div>
                </Form.Group>
              </div>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
      <Certification_Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        modalHeadingText={"View Legal Entity"}
        imgSrc={modalImage}
        btnText={"Download"}
      />
    </>
  );
}

export default Legel_Entity_view_offcanvas;
